'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nodeEmoji = require('node-emoji');

var _nodeEmoji2 = _interopRequireDefault(_nodeEmoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMOJI_REGEXP = /:\+1:|:-1:|:[\w-]+:/g;

var transformEmojis = function transformEmojis(doc) {
  var resultMap = {};
  var result = void 0;

  while ((result = EMOJI_REGEXP.exec(doc)) !== null) {
    resultMap[result] = true;
  }

  Object.keys(resultMap).forEach(function (result) {
    doc = doc.replace(new RegExp(result, 'g'), _nodeEmoji2.default.get(result.replace(/:/g, '')));
  });

  return doc;
};

exports.default = transformEmojis;